<template>
  <div class="scene-view">
    <div
      id="engineContainer"
      class="engine-container"
      ref="engineContainer"
      :style="`visibility:${canvasVisible ? 'visible' : 'hidden'}`" />
    <loading
      v-if="showpercentage"
      :percentage="percentage" />
  </div>
</template>

<script>
import loading from './Loading.vue'

import { isTemplateVersionConsistentWithEngine } from '@/utils/generalMethods'

// WMTS类型数据不设置dataSetCRS和engineOrigin，因此不再视为GIS数据进行处理
const GIS_DATA_TYPE = [11, 13]

export default {
  data() {
    return {
      percentage: 0, // 进度条数值
      showpercentage: true, // 是否显示进度条
      canvasVisible: false,

      isStartLoadDataSet: false
    }
  },
  props: {
    modelClick: Function,
    loadMainScene: Function,
    onMainSceLoaded: Function
  },
  components: {
    loading
  },
  mounted() {
    this.addEventListener()
  },
  beforeDestroy() {
    this.loading && this.loading.close()

    this.unloadAllMainSce()
    this.removeEventListener()
    this.showpercentage = false
  },
  methods: {
    addEventListener() {
      document.addEventListener('REDataSetLoadProgress', this.LoadProgress)
      document.addEventListener('RESystemEngineCreated', this.onRealBIMInitSys)
      document.addEventListener('REDataSetLoadFinish', this.onLoadMainSce)
      document.addEventListener('RESystemRenderReady', this.showCanvas)
      document.addEventListener('RESystemSelElement', this.RealBIMSelModel)
      document.addEventListener('mousedown', this.onMouseDown)

      window.addEventListener('beforeunload', this.onBeforeUnload)
      window.addEventListener('resize', this.onResize)
    },
    removeEventListener() {
      document.removeEventListener('REDataSetLoadProgress', this.LoadProgress)
      // prettier-ignore
      document.removeEventListener('RESystemEngineCreated', this.onRealBIMInitSys)
      document.removeEventListener('REDataSetLoadFinish', this.onLoadMainSce)
      document.removeEventListener('RESystemRenderReady', this.showCanvas)
      document.removeEventListener('RESystemUIEvent', this.onUIClick)
      document.removeEventListener('RESystemSelElement', this.RealBIMSelModel)
      document.removeEventListener('mousedown', this.onMouseDown)
    },
    initEngine() {
      window.BlackHole3D = window.BlackHole3D ? window.BlackHole3D : {}
      window.BlackHole3D.canvas = document.getElementById('engineCanvas')

      if (typeof window.BlackHole3D.RealBIMWeb === 'undefined') {
        window.BlackHole3D = window.CreateBlackHoleWebSDK(window.BlackHole3D)
      }
    },
    onMouseDown(e) {
      // 按下鼠标中键时，禁用滚动
      if (e.button === 1) {
        e.preventDefault()
      }
    },
    onRealBIMInitSys() {
      const timer = setInterval(() => {
        if (this.isEnginePreLoaded()) {
          clearInterval(timer)
          this.copyCanvas()

          this.loadMainScene()
        }
      }, 500)
    },
    getDataSetCRS(dataSet) {
      if (dataSet.dataSetType === 10) return null
      if (GIS_DATA_TYPE.includes(dataSet.dataSetType)) {
        return dataSet.engineCRS
      } else {
        return dataSet.dataSetCrs
      }
    },
    getEngineOrigin(dataSet) {
      if (dataSet.dataSetType === 10) return null
      let origin = ''
      if (GIS_DATA_TYPE.includes(dataSet.dataSetType)) {
        origin = dataSet.engineOrigin
      } else {
        origin = dataSet.descOrigin
      }

      if (origin) {
        origin = origin.split(',').map(Number)
        return origin
      } else {
        return null
      }
    },
    async loadBimVersionCompare(modelInfo) {
      this.isStartLoadDataSet = true

      const isVersionConsist = await isTemplateVersionConsistentWithEngine()
      const BlackHole3D = window.BlackHole3D
      if (!isVersionConsist) {
        const dataSetList = [
          {
            dataSetId: 'res_skybox',
            resourcesAddress: window.skyBoxUrl
          }
        ]
        BlackHole3D.Model.loadDataSet(dataSetList)

        BlackHole3D.Common.setMaxResMemMB(2000)
        BlackHole3D.Common.setExpectMaxInstMemMB(1900)
        BlackHole3D.Common.setExpectMaxInstDrawFaceNum(10000000)
        BlackHole3D.Common.setPageLoadLev(2)
        this.$message.error('请升级SDK版本至3.2.0.3247之后的版本')
        return
      }

      if (!modelInfo.length) {
        this.canvasVisible = true
        this.showpercentage = false
        this.onLoadMainSce()
        return
      }

      let dataSetList = []
      modelInfo.forEach(item => {
        let obj = {
          dataSetId: item.resId,
          resourcesAddress: window.isMinIO
            ? `${item.resourcesAddress}${item.resId}`
            : item.resourcesAddress,
          dataSetCRS: this.getDataSetCRS(item),
          useTransInfo: true,
          useAssginVer: true,
          assginVer: item.assginVer,
          useAssginVer2: true,
          assginVer2: item.assginVer2,
          transInfo: [
            item.scale.split(' ').map(Number),
            item.rotate.split(' ').map(Number),
            item.translation.split(' ').map(Number)
          ],
          engineOrigin: this.getEngineOrigin(item)
        }
        dataSetList.push(obj)
      })
      BlackHole3D.Model.loadDataSet(dataSetList)

      BlackHole3D.Common.setMaxResMemMB(2000)
      BlackHole3D.Common.setExpectMaxInstMemMB(1900)
      BlackHole3D.Common.setExpectMaxInstDrawFaceNum(10000000)
      BlackHole3D.Common.setPageLoadLev(2)

      // prettier-ignore
      BlackHole3D.setViewMode(BlackHole3D.REVpTypeEm.BIM, BlackHole3D.REVpTypeEm.BIM, BlackHole3D.REVpRankEm.LR)
    },
    onLoadMainSce() {
      if (!this.isStartLoadDataSet) return

      this.canvasVisible = true
      this.showpercentage = false

      if (this.onMainSceLoaded) {
        this.onMainSceLoaded()
      }
    },
    LoadProgress(e) {
      if (!this.isStartLoadDataSet) return

      let percentage = e.detail.progress
      if (percentage < 10) {
        this.fromZeroFlag = true
      }
      if (percentage === 12 && this.fromZeroFlag) {
        percentage = 10
      }

      this.percentage = percentage
    },
    RealBIMSelModel(e) {
      let eleinfo = window.BlackHole3D.Probe.getCurCombProbeRet()
      this.setSelElemsBlendAttr()

      if (this.modelClick) {
        this.modelClick(eleinfo)
      }
    },
    showCanvas() {
      // this.canvasVisible = true;
      window.BlackHole3D.canvas.focus()
    },
    onBeforeUnload() {
      this.releaseEngine()
    },
    onResize() {
      this.setCanvasSize()
    },
    unloadAllMainSce() {
      // window.BlackHole3D.REdelAllWaters();
      window.BlackHole3D.CAD.unloadCAD()
      window.BlackHole3D.Model.unloadAllDataSet()
      window.BlackHole3D.Panorama.unloadDataSet([])
    },
    releaseEngine() {
      window.BlackHole3D.releaseEngine()
    },
    highLightCompareEmem(datasetId, childNodeIds) {
      // 根据项目id场景组id定位
      window.BlackHole3D.BIM.delAllSelElems()
      window.BlackHole3D.BIM.addToSelElems(datasetId, childNodeIds)
      window.BlackHole3D.Camera.setCamLocateToElem(
        [
          {
            dataSetId: datasetId,
            elemIdList: childNodeIds
          }
        ],
        1.0
      )
    },
    setSelElemsBlendAttr() {
      const BlackHole3D = window.BlackHole3D
      let blendAttr = BlackHole3D.BIM.getSelElemsBlendAttr()
      blendAttr.elemClr = new BlackHole3D.REColor(255, 0, 0, 200)
      blendAttr.clrWeight = 128
      blendAttr.alphaWeight = 200
      BlackHole3D.BIM.setSelElemsBlendAttr(blendAttr)
    },
    setCanvasSize() {
      const domRef = this.$refs.engineContainer
      if (domRef) {
        window.BlackHole3D.m_re_em_window_width = domRef.clientWidth
        window.BlackHole3D.m_re_em_window_height = domRef.clientHeight
      }
    },
    copyCanvas() {
      const engineContainer = this.$refs.engineContainer
      const engineCanvas = document.getElementById('engineCanvas')
      engineContainer.append(engineCanvas)

      this.setCanvasSize()
    },
    isEnginePreLoaded() {
      let isPreLoaded = false
      const engineCanvas = document.getElementById('engineCanvas')
      const classList = engineCanvas.classList
      if (classList.contains('is-loaded')) {
        isPreLoaded = true
      }
      return isPreLoaded
    },
    isEngineCanvasExist() {
      let isExist = false
      const engineCanvas = document.getElementById('engineCanvas')
      if (engineCanvas) {
        isExist = true
      } else {
        isExist = false
      }
      return isExist
    },
    createEngineCanvas() {
      const engingCanvasDom = document.createElement('canvas')
      engingCanvasDom.id = 'engineCanvas'
      engingCanvasDom.classList.add('engine-canvas-box')
      // prettier-ignore
      engingCanvasDom.oncontextmenu = e => { e.preventDefault() }
      engingCanvasDom.tabIndex = '1'

      const engineContainer = document.getElementById('engineContainer')
      engineContainer.append(engingCanvasDom)
    }
  }
}
</script>

<style lang="less" scoped>
.scene-view {
  position: relative;
  width: 100%;
  height: 100%;
  background: var(--eng-loading-bgColor);

  .engine-container {
    height: 100%;
    :deep(.engine-canvas-box) {
      outline: none;
      &:focus {
        outline: none;
      }
    }
  }
}
</style>
